import React from "react";

// Components
import CustomTitle from "./CustomTitle";
import CustomParagraph from "./CustomParagraph";
import { Flex } from "antd";
import CustomImage from "./CustomImage";

const ShowMessage = ({ icon, heading, text, children, paragraphFontSize = "16px" }) => {
  return (
    <>
      <div className="show-message-container">
        <Flex justify="center" style={{ marginBottom: "24px" }}>
          {icon && (
            <Flex
            className="zl-verify-img"
              align="center"
              justify="center"
              style={{
                width: "100px",
                height: "100px",
                borderRadius: "50%",
                backgroundColor: "#3D81FF",
                
              }}
            >
              <CustomImage src={icon} preview={false} />
            </Flex>
          )}
        </Flex>

        <CustomTitle
        className="auth-title"
          text={heading}
          fontSize="32px"
          fontWeight="700"
          lineHeight="40px"
          color="#000"
          marginBottom="12px"
          textAlign="center"
        />

        <CustomParagraph
          text={text}
          fontSize={paragraphFontSize}
          fontWeight="400"
          lineHeight="24px"
          color="#000"
          marginBottom="24px"
          textAlign="center"
        />

        {children}
      </div>
    </>
  );
};

export default ShowMessage;
